export const LISTING_SOURCE = Object.freeze({
  STANDARD: 'STANDARD',
  THIRD_PARTY: 'THIRD_PARTY',
});
